import React, {useState,useEffect}from "react";
import { Button,Menu,Typography,Avatar } from "antd";
import{Link} from "react-router-dom";
import { HomeOutlined,MoneyCollectOutlined,BulbOutlined,FundOutlined, MenuOutlined} from "@ant-design/icons";
import icon from "../images/icons8-miner-100.png"
import MenuItem from "antd/lib/menu/MenuItem";

const Navbar = () => {

    const [activeMenu, setActiveMenu] = useState(true);
    const [screenSize, setScreenSize] = useState(undefined);
  
    useEffect(() => {
      const handleResize = () => setScreenSize(window.innerWidth);
  
      window.addEventListener('resize', handleResize);
  
      handleResize();
  
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    useEffect(() => {
      if (screenSize <= 800) {
        setActiveMenu(false);
      } else {
        setActiveMenu(true);
      }
    }, [screenSize]);

    return(
        <div className="nav-container" >
            <div className="logo-container">
                <Avatar src={icon} size="large"/>
                <Typography.Title level={2} className="logo">
                    <Link to="/" style={{color: "#5C3D2E"}}>Cryptopedia</Link>
                </Typography.Title>
                <Button className="menu-control-container" onClick={() => setActiveMenu(!activeMenu)}><MenuOutlined /></Button>
            </div>
            {activeMenu && (
                <Menu style={{backgroundColor: "#FABB51",color: "#146356"}}>
                  <MenuItem icon={<HomeOutlined/>}>
                      <Link to="/" style={{color: "#5C3D2E"}}>Home</Link>
                  </MenuItem>
                  <MenuItem icon={<FundOutlined/>}>
                      <Link to="/cryptocurrencies" style={{color: "#5C3D2E"}}>Cryptocurrencies</Link>
                  </MenuItem>
                  <MenuItem icon={<BulbOutlined/>}>
                      <Link to="/news" style={{color: "#5C3D2E"}}>News</Link>
                  </MenuItem>
              </Menu>
            )}
        </div>
    );
}

export default Navbar